import { api } from "@/api";
import { invalidateStorageQueries, type StorageBooking } from "./storage";

export const cancelStorageBooking = async (bookingId: string) => {
  const { body } = await api.post<StorageBooking>(
    `/storage/bookings/${bookingId}/cancel`,
  );
  invalidateStorageQueries();
  return body;
};
